import React, { useEffect, useState } from 'react';
import { CdsContentPanel, CdsDataTable } from 'clayco-component-library/lib';
import ApiProvider from '../../../apiProvider';
import { useMsal } from '@azure/msal-react';
import ChangeReview from './changeReview';
import { useNavigate } from 'react-router-dom';

const AdminView = ({ setMenuOptions }) => {
    const navigate = useNavigate();
    const { accounts, instance } = useMsal();
    const [pendingChanges, setPendingChanges] = useState([]);
    const [gridItems, setGridItems] = useState([]);
    const [modalData, setModalData] = useState();
    const [reloadChange, setReloadChange] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true); // Add loading state
    const [error, setError] = useState(null); // Add error state
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const gridColumns = ['Name', 'Change', 'Submitted On'];
    const dataKeys = ['name', 'change', 'submittedOn']; // Match the mapped fields for grid items

    const changeTypes = {
        1: "Address",
        2: "Name",
        3: "Personal Email",
        4: "Personal MobilePhone",
        5: "Emergency Contact"
    };

    const loadPendingChanges = async () => {
        setLoading(true);
        setError(null); // Clear any previous errors
        try {
            const results = await apiProvider.Get("Profile/GetPending");

            if (!results.error) {
                if (results.length > 0) {
                    setPendingChanges(results);
                    setGridItems(results.map((item) => ({
                        name: item.employeeName + " - " + item.employeeNumber,
                        change: changeTypes[item.changeType],
                        submittedOn: new Date(item?.modifiedOn)?.toLocaleDateString(),
                        id: item.id
                    })));
                } else {
                    setPendingChanges([]);
                    setGridItems([]);
                }
            } else {
                setError("Failed to load pending changes. Please try again later.");
            }
        } catch (err) {
            setError("An error occurred while fetching pending changes.");
        } finally {
            setLoading(false);
        }

        console.log("Pending Changes: ", pendingChanges);
        console.log("Grid Items: ", gridItems);
    };

    useEffect(() => {
        setMenuOptions("Profile/Admin");
    }, []);

    useEffect(() => {
        console.log("ran")
        loadPendingChanges();
    }, [reloadChange]);

    const reviewChange = async (item) => {
        const change = pendingChanges.find((pc) => pc.id === item.id);
        console.log("c",change)
        setModalData(change);
        setShowModal(true);

        navigate(`/Profile/Admin/${item.id}`, { state: { change } });
    };

    return (
        <>
            {showModal ? (
                <ChangeReview
                    show={showModal}
                    setShow={setShowModal}
                    changeInfo={modalData}
                    apiProvider={apiProvider}
                    reloadChange = {reloadChange}
                    setReloadChange = {setReloadChange}
                />
            ) : (
                <CdsContentPanel
                    title={"Pending Employee Changes"}
                    collapsible={false}
                    hideFooter={true}
                >
                    {loading ? (
                        <div>Loading pending changes...</div>
                    ) : error ? (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '150px',
                            textAlign: 'center',
                            color: '#B00020',
                            backgroundColor: '#FFF4F4',
                            borderRadius: '4px',
                            padding: '1rem',
                            fontWeight: '500'
                        }}>
                            {error}
                        </div>
                    ) : gridItems.length === 0 ? (
                        <div>There are no pending change requests.</div>
                    ) : (
                        <CdsDataTable
                            columns={gridColumns}
                            dataKeys={dataKeys}
                            data={gridItems}
                            usePaging={false}
                            pageSize={true}
                            fetchData={loadPendingChanges}
                            darkMode={true}
                            pagingControlMode={'bottom'}
                            clickableRow={true}
                            onRowClick={reviewChange}
                        />
                    )}
                </CdsContentPanel>
            )}
        </>
    );
};

export default AdminView;